import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import EntryPoint from "Engine/EntryPoint";
import RelaxModel from "Base/model/RelaxModel";
import StatesManager from "Engine/base/states/StatesManager";
import GameModel from "../model/GameModel";

let FEIM;
export default class PostMessages {

    constructor() {
        FEIM = window["FEIM"];
        this.addListeners();
    }

    delayedCall(callback) {
        TweenMax.delayedCall(20, () => callback(), [true], this, true);
    }

    init(session_id, user_id) {
        const platform = RelaxModel;
        this.initInner(
            session_id,
            user_id,
            platform
        );
        console.log('platform', platform)
        this.isInitExternalRC = platform.rcenable && platform.rciframeurl != null;

        if (!this.isInitExternalRC) {
            document.getElementById('rg_pause_modal') &&
            document.getElementById('rg_pause_modal').remove();
        }
    }

    initInner(sid, user_id, platfom) {
        const {gameServerAPIendpointURL, currency} = platfom;
        if (FEIM) {
            this._isInit = true;
            const config = {
                clientConfig: {
                    buttonEventsIframe: false,
                    gameServerAPIendpointURL,
                },
                loginResponse: {sid, stats: {currency}},
                handleRgPostMessageAPI: true,
                handleFeaturePause: true,
                //showErrorMessageCallback: MY_GAME.showInGameErrorMessage,
            }
            FEIM.configure(config);
        }
    }

    addListeners() {
        GlobalDispatcher.add('stateEnd:stopRollingState', this.stopRollingState, this);
        GlobalDispatcher.add('realityCheck:continue', this.rcContinue, this);
        GlobalDispatcher.addOnce('stateStart:splashScreenState', this.onStartSplashScreenState, this);
        GlobalDispatcher.addOnce('stateEnd:splashScreenState', this.onEndSplashScreenState, this);

        GlobalDispatcher.add('dataProvider:hasResponse', this.onResponse, this);

        const FEIMEventMap = {
            initialized: (value) => {
            },
            exitingGame: () => {
            },
            errorMessageDismissed: (value) => {
                //If you do not want to use showError, this can be used to detect when an error message popup is dismissed in the operator window.
            },
            errorMessageDisplayed: (value) => {
                //An error message was displayed in the operator window.
            },
            toggleGameHelp: (details = {}) => {
                console.log(details)
                const {type = 'switch'} = details;
                GlobalDispatcher.dispatch('paytable:open', {page: 'RULES', type});
            },
            togglePaytable: (details = {}) => {
                console.log(details)
                const {type = 'switch'} = details;
                GlobalDispatcher.dispatch('paytable:open', {page: 'PAYTABLE', type});
            },
            freeze: () => {
                this.postMessagePausedState = {/*realityCheck: {}*/};
                this.pauseState();
            },
            unfreeze: () => {
                this.rcContinue();
            },
            pauseAutoPlay: () => {
                GlobalDispatcher.dispatch('autoplay:setActive', false);
            },
            refreshBalance: () => {
                GlobalDispatcher.dispatch('request:getBalance');
            },
            updateSettings: (event) => {
                console.log('updateSettings')
                const {fastPlay, sounds} = event;

                if (sounds !== undefined) {
                    EntryPoint.GameSettings.soundMute = EntryPoint.GameSettings.musicMute = !sounds;
                }
                if (fastPlay !== undefined) {
                    EntryPoint.GameSettings.quickSpin = fastPlay;
                }

                this.onUpdateSettings(event);
            }
        }

        Object.entries(FEIMEventMap).map(([key, func]) => FEIM.on[key](func));
    }

    displayMenu(details, stateModel) {
        if (!details || details.type === 'toggle') {
            stateModel.isShowMenu = !stateModel.isShowMenu;
        } else {
            stateModel.isShowMenu = details && details.type === "show";
        }
    }

    rcContinue() {
        if (this.postMessagePausedState) {
            this.postMessagePausedState = null;
            StatesManager.currentState.stateData.name === 'stopRollingState'
            && StatesManager.onStateFinish('stopRollingState');

            GlobalDispatcher.dispatch('stateManager.stateChanged', 'resume');

            const {Game: {main}} = EntryPoint;
            this.realityCheckContainer = main.getChildByName('RealityCheckContainer');
            this.delayedCall(() => this.realityCheckContainer.onContinueClick());
        }
    }

    set postMessagePausedState(pauseData) {
        this.pauseData = pauseData;
    }

    get postMessagePausedState() {
        return this.pauseData;
    }

    onResponse(data) {
        switch (data.params.action) {
            case 'ping':
                if (this.useInternalRCDialog()) {
                    this.realityCheckContainer.show();
                }
                const {totalSessionMinutes} = RelaxModel.realityCheck;
                const sessionTime = Math.round(totalSessionMinutes * 60);
                break;

            case 'init':
                this.init(data.params.session, RelaxModel.ticket)
                break;
        }
    }

    onPauseState(data) {
        const {realityCheck, sessionTime = 0} = data;
        //console.log('sessionTime', sessionTime);

        if (FEIM) {
            let response = '';
            if (realityCheck && RelaxModel.realityCheck) {

                if (sessionTime) {
                    //RgPostMessageAPI.reportPaused({sessionTime: sessionTime});
                } else {
                    GlobalDispatcher.dispatch('request:ping');
                }
                //Show reality check result
                //RelaxModel.rcShowResult && this.sendGetSessionResult();
                return;
            }

            this.delayedCall(() => GlobalDispatcher.dispatch(
                'stateManager.stateChanged',
                'pause'));

            //RgPostMessageAPI.reportPaused(response);
        }
    }

    useInternalRCDialog() {
        return !RelaxModel.rciframeurl;
    }


    pauseState() {
        this.postMessagePausedState
        && this.onPauseState(this.postMessagePausedState)
    }

    stopRollingState() {
        this.pauseState();
    }

    onStartSpin() {
        const slotModel = EntryPoint.GameModel
        const {balance} = slotModel;
        FEIM.send.roundStarted({balance: balance});
    }

    onRoundFinished({freeSpinComplete = false} = {}) {
        const slotModel = EntryPoint.GameModel;

        const {balance, totalWin, totalBet, freeSpins }= slotModel;
        const {totalWin: totalWinFeature} = freeSpins || {};

        FEIM.send.roundFinished({
            balance: balance,
            win: {win: freeSpinComplete ? totalWinFeature : totalWin},
            bet: totalBet
        });
    }

    onAutoPlayStarted() {
        FEIM.send.autoPlayStarted();
    }

    onAutoPlayFinished() {
        FEIM.send.autoPlayFinished();
    }

    onFeatureStarted() {
        FEIM.send.featureStarted();
    }

    onFeatureFinished() {
        FEIM.send.featureFinished();
    }

    onStartSplashScreenState() {
        this.onReportUIState({splashScreenVisible: true});
    }

    onEndSplashScreenState() {
        this.onReportUIState({splashScreenVisible: false});
    }

    onErrorMessage(errorMessage) {
        FEIM.send.errorMessage(errorMessage);
    }

    onShowHistory() {
        FEIM.send.showHistory();
    }

    onExitGame() {
        FEIM.send.exitGame();
    }

    onReportUIState(uiState) {
        FEIM.send.reportUIState(uiState);
    }

    onBetUpdate(bet) {
        FEIM.send.betUpdate(bet);
    }

    onUpdateSettings(gameSettings) {
        FEIM.send.updateSettings(gameSettings);
    }

    onBalanceUpdate() {
        const slotModel = EntryPoint.GameModel;
        const {balance} = slotModel;
        FEIM.send.balanceUpdate(balance);
    }

    onRealityCheckContinue() {
        this.rcContinue();
    }

    gameLoadProgress(loadProgress) {
        const progress = Math.floor(loadProgress);
        FEIM && FEIM.send.gameLoadProgress(progress);
    }

    reportGameStartLoad() {
        if (FEIM) {
            FEIM.send.gameLoadStarted();
        }
    }
    reportGameReady() {
        if (FEIM) {
            FEIM.send.gameLoadCompleted();
        }
    }

    winLessOrEqualToBet() {
        const {totalWin: win, bet} = GameModel;
        const {jurisdiction} = RelaxModel;

        return jurisdiction === 'UK'
            && (win <= bet)
    }
}
